import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields } from "app/main/std";
import { observeResource } from "kea-resource";

import { FiltroClienteComponent } from "./filtro";
type Entity = models.ClienteView;
import { columnas } from "./columns";
const resource = resources.Cliente;

export interface State {
    filtro: models.FiltroCliente;
}

export class ClienteList extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);

        this.state = {
            filtro: {
                Limite: 500,
                EsDeCredito: null
            }
        };
    }

    filtro = (state: State) => state.filtro;
    items = createSelectorRx(this.filtro, filtro => observeResource(resources.Cliente.Query, filtro));
    cantidadClientesConConvenio = observeResource(resources.Cliente.ObtenerCantidadClienteConvenio);
    cantidadClientesRegistrados = observeResource(resources.Cliente.ObtenerCantidadClientesRegistrados);

    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar cliente?", x.Nombre)) {
            await resource.delete(x.IdCliente);
        }
    }

    onEdit = (x: Entity) => history.go("/catalogos/Cliente/" + x.IdCliente);
    onAgregar = () => history.go("/catalogos/Cliente/new");
    onRegresar = () => history.go("/catalogos");

    render() {
        const cols = columnas(this);
        const items = this.items(this.state);
        const cantidadClientesConConvenio = this.cantidadClientesConConvenio;
        const cantidadClientesRegistrados = this.cantidadClientesRegistrados;
        return (
            <div>
                <kea.Title titulo="Clientes" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <FiltroClienteComponent value={this.state.filtro} onChange={x => this.setState({ filtro: x })} />
                {kea.autogrid(6, [
                    <kea.Number value={cantidadClientesRegistrados} label="Cantidad de clientes registrados:" readonly />,
                    <kea.Number value={cantidadClientesConConvenio} label="Cantidad de clientes con convenio:" readonly />,
                ])}
                <kea.Grid2 columnas={cols} cookieKey={"ClienteListCookieKey"} items={items} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/list/list.tsx